import React, { forwardRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Components
import { Typography } from '../../../../../components';

// Styles
import * as S from './PaymentOnboardingStep.styles';

export const PaymentOnboardingStep = forwardRef(({

	updateHeight,
	isVisible,
}, ref) => {
	const navigate = useNavigate();
	const stateLocale = useSelector((state) => state.locale.value);

	useEffect(() => {
		if (isVisible && updateHeight) {
			updateHeight(true);
		}
	}, [isVisible, updateHeight]);

	const handlePayment = async () => {
		try {
			const res = await fetch('/_api/v1/payments/checkout-session', {
				method: 'POST',
				credentials: 'include',
			});

			const data = await res.json();
			console.log('stripe response:', data);

			if (data?.session?.url) {
				window.location.href = data.session.url;
			} else {
				navigate(`${stateLocale.localePath}/join/onboarding/payment-cancel`);
			}
		} catch (err) {
			navigate(`${stateLocale.localePath}/join/onboarding/payment-cancel`);
		}
	};

	return (
		<S.StepContainer ref={ref}>
			<S.ContentCard>
				<S.TitleSection>
					<S.TitleWrapper>
						<Typography tag="h3" weight="bold">
							Payment
						</Typography>
					</S.TitleWrapper>

					<S.DescriptionWrapper>
						<Typography tag="p">
							Be one of the first to Test Let&apos;s Talk at a discounted rate of $10.
						</Typography>
					</S.DescriptionWrapper>
				</S.TitleSection>

				<S.PlanCard>
					<S.PlanTitle>
						<Typography tag="h4" weight="bold">
							Program Access:
						</Typography>
					</S.PlanTitle>

					<S.FeatureList>
						<S.FeatureItem>
							<Typography tag="p" center={false}>
								Full access to guided health & well-being modules for parent and child.
							</Typography>
						</S.FeatureItem>

						<S.FeatureItem>
							<Typography tag="p" center={false}>
								Step-by-step family activities.
							</Typography>
						</S.FeatureItem>

						<S.FeatureItem>
							<Typography tag="p" center={false}>
								Interactive lessons with videos, quizzes, and a family communication journal.
							</Typography>
						</S.FeatureItem>
					</S.FeatureList>

					<S.PriceRow>
						<Typography tag="h3" weight="bold" center={false}>
							$10 for 3 months
						</Typography>
					</S.PriceRow>

					<S.SubText>
						<Typography tag="p" center={false}>
							Secure payment powered by Stripe. Apple Pay or Link accounts are not required. There are no refunds for this discounted rate.
						</Typography>
					</S.SubText>
				</S.PlanCard>

				<S.ButtonGroup>
					<S.PaymentLink as="button" onClick={handlePayment}>
						Go to Payment
					</S.PaymentLink>


				</S.ButtonGroup>
			</S.ContentCard>
		</S.StepContainer>
	);
});

PaymentOnboardingStep.propTypes = {

	updateHeight: PropTypes.func,
	isVisible: PropTypes.bool,
};

PaymentOnboardingStep.defaultProps = {
	updateHeight: null,
	isVisible: false,
};
